import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectIntroProps } from '../../../store/selectors/intro'

const IntroContainer = compose(
  connect(state => {
    const { loading } = state.customerProfile

    return {
      loading,
      ...selectIntroProps(state),
    }
  })
)

export default IntroContainer
